export const UPDATEDMTGOBJECT = '@dmtg/updateDMTGObject';

export function setDMTGObject(data) {
    return {
        type: UPDATEDMTGOBJECT,
        payload: data
    };
}
